import { DISABLE_USER_REQUEST, disableUserFailure, disableUserSuccess, logoutUser } from 'Redux/Action';
import { ofType }                                                                   from 'redux-observable';
import { EMPTY, from } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';

export function disableUserRequestEpic(action$, store$, { UserRepository }) {
    return action$.pipe(
        ofType(DISABLE_USER_REQUEST),
        mergeMap(action => from(
            UserRepository.disable(action.payload.password, action.payload.validTo)
                .then(() => {
                    const actions = [
                      disableUserSuccess(),
                    ];
                    if(action.payload.validTo > new Date()) {
                      actions.push(logoutUser());
                    }

                    return from(actions)
                })
                .catch(error => disableUserFailure(error)),
        )),
    );
}
